(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  const enqueue = task => { const result = queue.then(task, task); queue = result.catch(() => {}); return result; };
  const request = async (path, body) => {
    const response = await fetch(root() + path, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Unable to update bag');
    return data;
  };
  const refresh = async () => {
    const response = await fetch(root() + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Unable to refresh bag');
    const cart = await response.json();
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
    document.dispatchEvent(new CustomEvent('bbb:cart-updated',{detail:cart}));
    return cart;
  };
  class QuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-quick-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-quick-labels]').textContent);
      this.form = this.querySelector('form');
      this.native = this.querySelector('[data-quick-native]');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role=status]');
      this.querySelector('.bbb-quick-native').hidden = true;
      this.querySelector('[data-quick-options]').hidden = false;
      this.form.noValidate = true;
      this.querySelectorAll('[data-quick-size]').forEach(select => {
        [...select.options].filter(option => option.value).sort((a,b) => parseFloat(a.textContent)-parseFloat(b.textContent)).forEach(option => select.append(option));
      });
      this.addEventListener('change',() => this.selectVariant());
      this.form.addEventListener('submit',event => {
        event.preventDefault();
        if (this.busy) return;
        if (!this.variant?.available) {
          this.status.textContent = this.labels.choose;
          this.querySelector('select[data-quick-option]:invalid')?.focus();
          return;
        }
        this.busy = true;this.button.disabled = true;this.button.textContent = this.labels.adding;
        enqueue(async () => {
          await request('cart/add.js',{items:[{id:this.variant.id,quantity:1}]});
          const bag = document.querySelector('bbb-cart-page');
          if (bag) { window.location.reload(); return; }
          await refresh();
          this.status.textContent = this.labels.added;
        }).catch(error => this.status.textContent = error.message || this.labels.error).finally(() => {
          this.busy = false;this.selectVariant(false);
        });
      });
      this.selectVariant();
    }
    selectVariant(clear = true) {
      const selectors = [...this.querySelectorAll('[data-quick-option]')];
      const complete = selectors.every(select => select.value);
      this.variant = complete ? this.variants.find(variant => selectors.every(select => variant.options[Number(select.dataset.quickOption)] === select.value)) : null;
      this.native.value = this.variant?.id || '';
      if (clear) this.status.textContent = '';
      this.button.disabled = this.busy || (complete && !this.variant?.available);
      this.button.textContent = !complete ? this.labels.add : !this.variant ? this.labels.unavailable : !this.variant.available ? this.labels.soldOut : this.labels.add;
      if (this.variant) {
        this.querySelector('[data-quick-price]').textContent = this.variant.priceLabel;
        const compare = this.querySelector('[data-quick-compare]');
        if(compare){compare.textContent = this.variant.compareLabel || '';compare.hidden = !this.variant.compareLabel;}
      }
      selectors.forEach(select => [...select.options].forEach(option => {
        if (!option.value) return;
        option.disabled = !this.variants.some(variant => variant.available && variant.options[Number(select.dataset.quickOption)] === option.value && selectors.every(other => other === select || !other.value || variant.options[Number(other.dataset.quickOption)] === other.value));
      }));
    }
  }
  class CartPage extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('input',event => {
        if (event.target.matches('[data-cart-quantity]')) this.scheduleQuantity(event.target,350);
      });
      this.addEventListener('change',event => {
        if (!event.target.matches('[data-cart-quantity]')) return;
        this.scheduleQuantity(event.target,0);
      });
      this.addEventListener('click',event => {
        const step = event.target.closest('[data-quantity-step]');
        if (step) {
          const input = step.closest('.bbb-cart-stepper').querySelector('[data-cart-quantity]');
          if (Number(step.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
          this.scheduleQuantity(input,0);
          return;
        }
        const remove = event.target.closest('[data-remove-key]');
        if (remove) { event.preventDefault();clearTimeout(this.quantityTimer);this.change(Number(remove.dataset.cartLine),0); }
      });
      this.addEventListener('submit',event => {
        if (event.target.id !== 'BagForm-'+this.dataset.section) return;
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        const input = this.querySelector('[data-cart-quantity]:focus') || [...this.querySelectorAll('[data-cart-quantity]')].find(el=>el.value!==el.defaultValue);
        if (input) this.scheduleQuantity(input,0);
      });
    }
    scheduleQuantity(input,delay) {
      clearTimeout(this.quantityTimer);
      if (input.disabled || input.value === '' || !input.checkValidity() || input.value === input.defaultValue) return;
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0) return;
      this.quantityTimer = setTimeout(()=>this.change(Number(input.dataset.cartLine),quantity),delay);
    }
    disconnectedCallback() {clearTimeout(this.quantityTimer);}
    change(line, quantity) {
      if (!Number.isInteger(line) || line < 1) return;
      const status = this.querySelector('[data-cart-status]');
      status.textContent = this.dataset.updatingLabel;
      this.setAttribute('aria-busy','true');
      this.querySelectorAll('[data-cart-quantity],[data-cart-checkout],[data-quantity-step]').forEach(el => el.disabled = true);
      enqueue(async () => { await request('cart/change.js',{line,quantity}); window.location.reload(); }).catch(error => {
        status.textContent = error.message;
      }).finally(() => { this.removeAttribute('aria-busy');this.querySelectorAll('[data-cart-quantity],[data-cart-checkout],[data-quantity-step]').forEach(el => el.disabled = false); });
    }
  }
  class OutfitSlider extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-slide-track]');
      this.cards = [...this.track.querySelectorAll('bbb-quick-add')];
      this.prev = this.querySelector('[data-slide-prev]');
      this.next = this.querySelector('[data-slide-next]');
      this.querySelector('.bbb-slider-controls').hidden = false;
      const move = direction => {
        const current = this.cards.reduce((best,card,index) => Math.abs(card.offsetLeft-this.track.scrollLeft) < Math.abs(this.cards[best].offsetLeft-this.track.scrollLeft) ? index : best,0);
        const target = this.cards[Math.max(0,Math.min(this.cards.length-1,current+direction))];
        this.track.scrollTo({left:target.offsetLeft,behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      this.prev.addEventListener('click',()=>move(-1));
      this.next.addEventListener('click',()=>move(1));
      this.track.addEventListener('scroll',()=>this.update(),{passive:true});
      this.track.addEventListener('keydown',event=>{
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight'?1:-1);}
      });
      if ('ResizeObserver' in window) {this.observer = new ResizeObserver(()=>this.update());this.observer.observe(this.track);}
      this.update();
    }
    disconnectedCallback() {this.observer?.disconnect();}
    update() {
      const max = this.track.scrollWidth-this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max-2;
    }
  }
  if (!customElements.get('bbb-outfit-slider')) customElements.define('bbb-outfit-slider',OutfitSlider);
  if (!customElements.get('bbb-quick-add')) customElements.define('bbb-quick-add',QuickAdd);
  if (!customElements.get('bbb-cart-page')) customElements.define('bbb-cart-page',CartPage);
})();
